import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const EnquiryDetails = ({ children, className, ...props }) => {
    return (
        <h2
            className={[
                'govuk-heading-m govuk-!-margin-bottom-4',
                className
            ].join(' ') }
            {...props}
        >
            {children}
        </h2>
    );
};

EnquiryDetails.propTypes = {
    ...defaultAriaProps
};

export default EnquiryDetails;
